import React from "react";
import { MdArrowForward } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { useTable } from "react-table";
import tw from "tailwind-styled-components";

const Tables = ({ propertyType, recentTransaction }) => {
  const navigate = useNavigate();

  const data =
    propertyType === "All Property"
      ? recentTransaction?.allPropTrans || []
      : recentTransaction?.curPropTrans || [];

  const columns = React.useMemo(
    () => [
      {
        Header: "Tenant",
        accessor: "tenantName",
        Cell: ({ row }) => (
          <div>
            <div className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
              {row.original.tenantName}
            </div>
            <div className="text-xs text-gray-500 truncate max-w-[180px]">
              {row.original.propName}
            </div>
          </div>
        ),
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ row }) => (
          <div className="">
            <div className="text-sm font-semibold text-gray-900">
              ₹{row.original.amount.toLocaleString()}
            </div>
            <div className="text-xs text-gray-500 truncate max-w-[160px]">
              {row.original.name}
            </div>
          </div>
        ),
      },
      {
        Header: "Date",
        accessor: "collectionDate",
        Cell: ({ value }) =>
          new Date(value).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
          }),
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return (
    <Container>
      {/* Header */}
      <Header>
        <Title>Recent Transactions</Title>
        {/* <ViewAll onClick={() => navigate("/finance/collections")}>
          View all <MdArrowForward className="ml-1" />
        </ViewAll> */}
      </Header>

      {/* Table */}
      <TableWrapper>
        <Table {...getTableProps()}>
          <Thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                {headerGroup.headers.map((column) => (
                  <Th {...column.getHeaderProps()} key={column.id}>
                    {column.render("Header")}
                  </Th>
                ))}
              </tr>
            ))}
          </Thead>

          <Tbody {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.slice(0, 5).map((row) => {
                prepareRow(row);
                return (
                  <Tr
                    {...row.getRowProps()}
                    key={row.id}
                    // onClick={() =>
                    //   navigate(`/finance/collections/${row.original.id}`)
                    // }
                  >
                    {row.cells.map((cell) => (
                      <Td {...cell.getCellProps()} key={cell.column.id}>
                        {cell.render("Cell")}
                      </Td>
                    ))}
                  </Tr>
                );
              })
            ) : (
              <tr>
                <Td colSpan={3} className="text-center py-6 text-gray-400">
                  No transactions found
                </Td>
              </tr>
            )}
          </Tbody>
        </Table>
      </TableWrapper>
    </Container>
  );
};

const Container = tw.div`
  bg-white rounded-lg p-5
`;

const Header = tw.div`
  flex items-center justify-between mb-4
`;

const Title = tw.h3`
  text-sm font-semibold text-gray-700 uppercase tracking-wide
`;

const ViewAll = tw.button`
  text-sm text-blue-600 hover:text-blue-700
  flex items-center font-medium
`;

const TableWrapper = tw.div`
  overflow-x-auto
`;

const Table = tw.table`
  min-w-full border-separate border-spacing-y-1
`;

const Thead = tw.thead``;

const Th = tw.th`
  bg-gray-100 px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wide
`;

const Tbody = tw.tbody``;

const Tr = tw.tr`
  hover:bg-gray-50
  transition-colors
`;

const Td = tw.td`
  px-4 py-3 text-sm text-gray-700
`;

export default Tables;
